import { onShowCustomPreview } from '../actions/publicLazyActions';
import sxsStore from '../store/Store';
import { mutator } from 'satcheljs';

mutator(onShowCustomPreview, actionMessage => {
    const { customPreviewState } = actionMessage;
    sxsStore.customPreviewState = customPreviewState;
});
